import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetRewardsArg = {
  widgetId: string;
};

export function useWidgetRewards({ widgetId }: UseWidgetRewardsArg) {
  const widgetRewards = useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetRewards
  );
  return widgetRewards;
}
